/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Links_PositionInputs */

const cs_links_position = /** @type {(inputs: Links_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozice`)
};

const en_links_position = /** @type {(inputs: Links_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Links_PositionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const links_position = /** @type {((inputs?: Links_PositionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Links_PositionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_links_position(inputs)
	return cs_links_position(inputs)
});